export const IconInfo = () => (
  <svg viewBox='0 0 512 512' xmlns='http://www.w3.org/2000/svg'>
    <g>
      <path d='M16 0L16 512' opacity='0.3'></path>
      <path d='M32 0L32 512'></path>
      <path d='M48 0L48 512' opacity='0.3'></path>
      <path d='M64 0L64 512'></path>
      <path d='M80 0L80 512' opacity='0.3'></path>
      <path d='M96 0L96 512'></path>
      <path d='M112 0L112 512' opacity='0.3'></path>
      <path d='M128 0L128 512'></path>
      <path d='M144 0L144 512' opacity='0.3'></path>
      <path d='M160 0L160 512'></path>
      <path d='M176 0L176 512' opacity='0.3'></path>
      <path d='M192 0L192 512'></path>
      <path d='M208 0L208 512' opacity='0.3'></path>
      <path d='M224 0L224 512'></path>
      <path d='M240 0L240 512' opacity='0.3'></path>
      <path d='M256 0L256 512'></path>
      <path d='M272 0L272 512' opacity='0.3'></path>
      <path d='M288 0L288 512'></path>
      <path d='M304 0L304 512' opacity='0.3'></path>
      <path d='M320 0L320 512'></path>
      <path d='M336 0L336 512' opacity='0.3'></path>
      <path d='M352 0L352 512'></path>
      <path d='M368 0L368 512' opacity='0.3'></path>
      <path d='M384 0L384 512'></path>
      <path d='M400 0L400 512' opacity='0.3'></path>
      <path d='M416 0L416 512'></path>
      <path d='M432 0L432 512' opacity='0.3'></path>
      <path d='M448 0L448 512'></path>
      <path d='M464 0L464 512' opacity='0.3'></path>
      <path d='M480 0L480 512'></path>
      <path d='M496 0L496 512' opacity='0.3'></path>
      <path d='M0 16L512 16' opacity='0.3'></path>
      <path d='M0 32L512 32'></path>
      <path d='M0 48L512 48' opacity='0.3'></path>
      <path d='M0 64L512 64'></path>
      <path d='M0 80L512 80' opacity='0.3'></path>
      <path d='M0 96L512 96'></path>
      <path d='M0 112L512 112' opacity='0.3'></path>
      <path d='M0 128L512 128'></path>
      <path d='M0 144L512 144' opacity='0.3'></path>
      <path d='M0 160L512 160'></path>
      <path d='M0 176L512 176' opacity='0.3'></path>
      <path d='M0 192L512 192'></path>
      <path d='M0 208L512 208' opacity='0.3'></path>
      <path d='M0 224L512 224'></path>
      <path d='M0 240L512 240' opacity='0.3'></path>
      <path d='M0 256L512 256'></path>
      <path d='M0 272L512 272' opacity='0.3'></path>
      <path d='M0 288L512 288'></path>
      <path d='M0 304L512 304' opacity='0.3'></path>
      <path d='M0 320L512 320'></path>
      <path d='M0 336L512 336' opacity='0.3'></path>
      <path d='M0 352L512 352'></path>
      <path d='M0 368L512 368' opacity='0.3'></path>
      <path d='M0 384L512 384'></path>
      <path d='M0 400L512 400' opacity='0.3'></path>
      <path d='M0 416L512 416'></path>
      <path d='M0 432L512 432' opacity='0.3'></path>
      <path d='M0 448L512 448'></path>
      <path d='M0 464L512 464' opacity='0.3'></path>
      <path d='M0 480L512 480'></path>
      <path d='M0 496L512 496' opacity='0.3'></path>
    </g>
    <path d='M255.983 483.728C130.447 483.728 28.255 381.536 28.255 256S130.447 28.288 255.983 28.288c125.536 0 227.728 102.175 227.728 227.712S381.519 483.728 255.983 483.728zm181.039-408.75C388.663 26.619 324.365 0 256 0S123.338 26.602 74.978 74.978C26.602 123.337 0 187.635 0 256s26.585 132.663 74.978 181.038C123.337 485.398 187.635 512 256 512s132.663-26.586 181.022-74.962C485.398 388.662 512 324.365 512 256s-26.586-132.662-74.978-181.022z'></path>
    <path d='M298.656 181.998c0 6.216-2.331 11.524-7.043 15.888-4.695 4.365-10.35 6.547-16.963 6.547-6.647 0-12.3-2.183-17.046-6.547-4.745-4.381-7.109-9.672-7.109-15.888 0-6.2 2.364-11.524 7.109-15.938 4.728-4.415 10.416-6.63 17.046-6.63s12.267 2.215 16.963 6.63c4.712 4.415 7.043 9.738 7.043 15.938zm-2.563 149.74l-2.695 11.027c-8.084 3.191-14.565 5.638-19.377 7.308s-10.433 2.513-16.815 2.513c-9.804 0-17.426-2.414-22.849-7.175-5.44-4.795-8.151-10.863-8.151-18.203 0-2.86.182-5.786.595-8.779.43-2.993 1.075-6.365 1.984-10.118l10.119-35.827c.91-3.406 1.654-6.68 2.265-9.738s.926-5.853.926-8.382c0-4.579-.942-7.787-2.827-9.572s-5.472-2.695-10.813-2.695c-2.612 0-5.307.413-8.035 1.207-2.744.827-5.109 1.603-7.076 2.331l2.695-11.044c6.647-2.695 12.978-4.993 19.03-6.928s11.788-2.877 17.211-2.877c9.738 0 17.244 2.347 22.518 7.043 5.274 4.712 7.92 10.813 7.92 18.352 0 1.554-.166 4.298-.546 8.234-.363 3.902-1.041 7.506-2.034 10.779l-10.068 35.662c-.827 2.86-1.57 6.151-2.216 9.837-.661 3.654-.976 6.448-.976 8.332 0 4.728 1.058 7.969 3.175 9.688 2.116 1.703 5.803 2.579 11.011 2.579 2.464 0 5.241-.447 8.349-1.289 3.075-.86 5.34-1.603 6.729-2.248z'></path>
  </svg>
)
